import { Action, applyMiddleware, compose, createStore, Reducer, Store } from "redux";
import thunk from "redux-thunk";
import { log } from "../utils";

function createStaticReducer<TState, TAction extends Action>(state: TState): Reducer<TState, TAction> {
    return (oldState: TState = state, action: TAction) => {
        log("static reducer", oldState, action);
        return oldState;
    };

}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const composeEnhancers = (globalThis as any)?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middlewares = [
    thunk
];

export function createStaticStore<TState, TAction extends Action>(state: TState): Store<TState, TAction> {
    const reducer = createStaticReducer<TState, TAction>(state);
    return createStore(reducer, composeEnhancers(applyMiddleware(...middlewares)));
}
